import React from 'react';

interface LoadingStateProps {
  type?: 'spinner' | 'skeleton';
  message?: string;
  height?: string;
  className?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({ 
  type = 'spinner',
  message = 'Loading...',
  height = 'aspect-video',
  className = ''
}) => {
  if (type === 'skeleton') {
    return (
      <div className={`animate-pulse ${height} ${className}`}>
        <div className="h-full bg-background-secondary rounded-lg">
          <div className="h-full flex flex-col">
            <div className="flex-1 bg-gradient-to-r from-background-secondary via-background to-background-secondary" />
            <div className="p-4 space-y-3">
              <div className="h-4 bg-background rounded w-3/4" />
              <div className="h-4 bg-background rounded w-1/2" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${height} bg-background-secondary rounded-lg ${className}`}>
      <div className="flex flex-col items-center">
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 border-4 border-brand/30 rounded-full" />
          <div className="absolute inset-0 border-4 border-brand border-t-transparent rounded-full animate-spin" />
        </div>
        <p className="mt-4 text-content-secondary">{message}</p>
      </div>
    </div>
  );
};

export default LoadingState;